import React from 'react';
import styles from '../../styles/countryadmissionsday.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import { useRouter } from 'next/router';
import Button from 'react-bootstrap/Button';
import useZipmeLink from '../../hooks/useZipmeLink';
import { isFrappeOrJotFormClass } from '../../utils/helpers';
interface Props {
  whystudydata: any;
  jotformId: string;
  externalLink : any;
}

const WhyStudyCountry: React.FC<Props> = ({ whystudydata, jotformId, externalLink }) => {
  const router = useRouter();
   const { zipmeLink, generateLink } = useZipmeLink();
  return (
    <>
      <div
        className={styles.studentSpecialOffer}
        style={{ backgroundColor: whystudydata?.sectionBgColor || '#EFEFFA' }}
      >
        <Container>
          <Row className={styles.row}>
            <Col xl={7} lg={7} md={12} sm={12} className={styles.stuImgtextd}>
              <div className={styles.heading}>
                <h2>{whystudydata?.sectionTitle}</h2>
              </div>
              <div>{whystudydata?.sectionDesc}</div>
              <div className={styles.heading}>
                <h2>{whystudydata?.sectionFactsTitle}</h2>
              </div>
              <div className={styles.OffersContent}>
                <ul className={styles.ulliQuick}>
                  {whystudydata?.quickFacts?.length > 0
                    ? whystudydata.quickFacts.length > 0 &&
                    whystudydata.quickFacts.map(
                      (quickFact: any, ind: number) => {
                        return (
                          <div key={ind} className={styles.ulliQuickli}>
                            <div className={styles.quickImg}>
                              <CustomImage
                                src={
                                  quickFact?.imageUrl ||
                                  '/images/admissionsday/popularstart.png'
                                }
                                width={35}
                                height={35}
                                className={styles.cardImg}
                                alt='alttag'
                              />
                            </div>
                            <span> {quickFact.title}</span>
                          </div>
                        );
                      }
                    )
                    : whystudydata?.sectionFacts?.length > 0 &&
                    whystudydata.sectionFacts.map(
                      (offer: string, ind: number) => {
                        return <li key={ind}>{offer}</li>;
                      }
                    )}
                </ul>
              </div>
              <div className={styles.anchor}>
                <Button onClick={()=>{
                 !jotformId && generateLink(externalLink);
                }} className={`${styles.btnReg} ${jotformId ? `${isFrappeOrJotFormClass(jotformId)}` : '' }`}>
                  {router.asPath.includes('/company/')
                    ? 'Register Now'
                    : 'Enquire Now'}
                </Button>
              </div>
            </Col>
            <Col xl={5} lg={5} md={12} sm={12} className={styles.stuImgd}>
              <div className={styles.studyServSection}>
                <div className={styles.platformDivImg}>
                  <div className={styles.pica}>
                    <CustomImage
                      src={
                        whystudydata?.sectionImages[0]?.imageUrl ||
                        '/cana_a.svg'
                      }
                      width={200}
                      height={200}
                      alt='cana_a.svg'
                      objectFit='fill'
                    />
                  </div>
                  <div className={styles.picb}>
                    <CustomImage
                      src={
                        whystudydata?.sectionImages[1]?.imageUrl ||
                        '/cana_b.svg'
                      }
                      width={200}
                      height={280}
                      alt='cana_b.svg'
                      objectFit='fill'
                    />
                  </div>
                  <div className={styles.picc}>
                    <CustomImage
                      src={
                        whystudydata?.sectionImages[2]?.imageUrl ||
                        '/cana_c.svg'
                      }
                      width={200}
                      height={280}
                      alt='cana_c.svg'
                      objectFit='fill'
                    />
                  </div>
                  <div className={styles.picd}>
                    <CustomImage
                      src={
                        whystudydata?.sectionImages[3]?.imageUrl ||
                        '/cana_d.svg'
                      }
                      width={200}
                      height={200}
                      alt='cana_d.svg'
                      objectFit='fill'
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default WhyStudyCountry;
